module fdm.general {
    angular.module('fdm.general')
        .config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {
            dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .listState('airports', 'airports',
                    'airport/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                        })
                    .listState('pilots', 'pilots',
                    'pilot/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    });

                //.state('app.categories', {
                //    abstract: true,
                //    url: 'categories',
                //    template: '<div ui-view />'
                //})
                //.state('app.categories.activities', {
                //    url: '/activities',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/activities-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.species', {
                //    url: '/species',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/species-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.targets', {
                //    url: '/targets',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/targets-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.categories', {
                //    url: '/category',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.companyRoleInProject', {
                //    url: 'company-role-in-project',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/company-role-in-project-dynamic-list/dynamic-list-list'
                //                }
                //            }
                //        }]
                //    }
                //})

            });

}